import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import RadioComponent from 'shared/components/RadioComponent';
import Label from 'shared/components/Label';
import ConfirmModal from 'shared/components/ConfirmModal';

import { changeStencilsSide } from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';
import { selectStencils, selectStencilsSide } from 'shared/product_tabs/tab_stencils/slice/selectors';
import { TWO_SIDES, COMBINED } from 'shared/product_tabs/tab_stencils/data/constants';
import sides from 'shared/product_tabs/tab_stencils/data/stencilSides';

const StencilsSide = ({ label, required }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [newSideSelection, setNewSideSelection] = useState(null);

  const stencils = useSelector(selectStencils);
  const stencilsSide = useSelector(selectStencilsSide);

  const onChange = (new_side) => {
    if (stencilsSide === TWO_SIDES && new_side === COMBINED && stencils.filter((s) => {
      const { stencil_side, ...check_parameters } = s.parameters;
      return !_.isEmpty(check_parameters);
    }).length > 0) {
      setShow(true);
      setNewSideSelection(new_side);
      return;
    }
    dispatch(changeStencilsSide(new_side));
  };

  // eslint-disable-next-line no-unused-vars
  const onClickYes = () => {
    dispatch(changeStencilsSide(newSideSelection));
    setShow(false);
  };

  const items = sides.map((side) => (
    <RadioComponent
      key={side.key}
      name="stencil_side"
      inputId={`stencils-side-${side.key}`}
      label={side.label}
      checked={stencilsSide === side.key}
      onChange={() => onChange(side.key)} />
  ));

  return (
    <>
      <div className="form-group">
        <Label label={label} required={required} />
        {items}
      </div>
      <ConfirmModal
        className="tab-stencils-confirm-modal"
        size="md"
        show={show}
        labelYes="Yes"
        labelNo="No"
        onClickYes={() => onClickYes()}
        onClickNo={() => setShow(false)}
        title={<h4 className="fw-bold mb-3">WARNING</h4>}>
        <p className="text-center">
          You are about to change the stencil side(s) from two stencils to combined stencil.
          This will fill all the parameters for the combined stencil using the top stencil form.
          Are you sure you want to continue?
        </p>
      </ConfirmModal>
    </>
  );
};

StencilsSide.defaultProps = {
  label: 'Stencil Side(s)',
  required: false,
};

export default StencilsSide;
